export default __webpack_public_path__ + "static/media/Clash_Cards_Champions.48e19911.mp4";